/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Consultationrequestdescription2Inputs */

const en__field_consultationrequestdescription2 = /** @type {(inputs: _Field_Consultationrequestdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you want to make a request for a consultation? Please let us know what it is about.`)
};

const de__field_consultationrequestdescription2 = /** @type {(inputs: _Field_Consultationrequestdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie eine Beratung anfragen? Dann lassen Sie uns hier kurz wissen, worum es geht.`)
};

/**
* | output |
* | --- |
* | "Do you want to make a request for a consultation? Please let us know what it is about." |
*
* @param {_Field_Consultationrequestdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_consultationrequestdescription2 = /** @type {((inputs?: _Field_Consultationrequestdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Consultationrequestdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_consultationrequestdescription2(inputs)
	return de__field_consultationrequestdescription2(inputs)
});
export { _field_consultationrequestdescription2 as "_field_consultationRequestDescription" }